export default [
  'Full time',
  '4 days',
  '3 days',
  '2 days',
  '1 day',
  'Evenings & weekends'
]
